import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { useFilters, useSortBy, useTable } from "react-table";

import { strCode } from "../../consts";
import { t } from "../../services";
import { useTableData } from "../../hooks";

import {
  CircleIconButton,
  FlexContainers,
  Paragraph2,
  SearchInput,
  SVG,
  Table,
  WrapperContainer
} from "../../components";
import { GroupsTableColumns } from "./GroupsTableColumns";

const GroupsTable = ({
  groups,
  editingGroup,
  loading,
  loadingChanges,
  setEditingGroup,
  onAdd,
  onEditSave,
  onEditCancel,
  onDelete
}) => {
  const [searchValue, setSearchValue] = useState("");

  const data = useTableData({
    loading: !!loading,
    data: groups,
    loadingPlaceholdersRows: 7
  });

  const columns = useMemo(() => GroupsTableColumns, []);
  const tableInstance = useTable(
    {
      columns,
      data
    },
    useFilters,
    useSortBy
  );

  const { setFilter } = tableInstance;

  const onAddNew = () => {
    const newGroup = {
      name: ""
    };

    onAdd(newGroup);
  };

  const handleFilterChange = (value) => {
    setFilter("name", value);
    setSearchValue(value);
  };

  return (
    <WrapperContainer width={"100%"}>
      <WrapperContainer width="100%" mb={16}>
        <SearchInput
          id="group-modal-search"
          value={searchValue}
          setValue={handleFilterChange}
          placeholder={t(strCode.SEARCH_GROUPS_PLACEHOLDER)}
        />
      </WrapperContainer>

      <Table
        tableInstance={tableInstance}
        maxTableHeight="108px"
        component={
          <WrapperContainer
            Container={FlexContainers.FlexColumnCenter}
            gap={16}
            height={groups.length ? 60 : 82}
            mt={groups.length ? 0 : 24}>
            {!groups.length && !loading && <Paragraph2>{t(strCode.NO_GROUPS_YET)}</Paragraph2>}

            <CircleIconButton
              onClick={onAddNew}
              disabled={!!editingGroup || groups.length >= 15 || loadingChanges || loading}
              tooltipLabel={t(strCode.ADD_GROUP_TITLE)}>
              <SVG.PlusIcon />
            </CircleIconButton>
          </WrapperContainer>
        }
        isLoading={loading}
        searchedText={searchValue}
        componentHeight={64}
        modalTable
        maxVisibleRows={1}
        callbackFn1={() => editingGroup}
        callbackFn2={onEditCancel}
        callbackFn3={(featureName) => onEditSave(featureName, editingGroup.name)}
        callbackFn4={onDelete}
        callbackFn5={setEditingGroup}
        callbackFn6={() => loadingChanges}
        showTableBorder
      />
    </WrapperContainer>
  );
};

GroupsTable.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired })).isRequired,
  editingGroup: PropTypes.shape({ name: PropTypes.string.isRequired }).isRequired,
  loading: PropTypes.bool,
  loadingChanges: PropTypes.bool,
  setEditingGroup: PropTypes.func.isRequired,
  setEditing: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEditSave: PropTypes.func.isRequired,
  onEditCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default GroupsTable;
